<template>
  <el-select v-model="selectValue" @change="changeOption"
             :disabled="disabled" placeholder="请选择"
             class="common-width" :clearable="clearable">
    <el-option
      v-for="item in bankList"
      :key="item.id"
      :label="item.bankName"
      :value="item.id"/>
  </el-select>
</template>

<script>
    export default {
        data() {
            return {
                selectValue: this.value,
                bankList: [],
            }
        },
        props: {
            /**
             * 机构类型 默认1
             */
            type: {
                type: Number,
                default: 1
            },
            /**
             * 机构级别 默认1
             */
            level: {
                type: Number,
                default: 2
            },
            /**
             * 父机构 默认无
             */
            parent: {
              type: Number|String,
              default: undefined
            },
            /**
             * 区域 默认无
             */
            area: {
              type: Number|String,
              default: undefined
            },
            /**
             * 默认选中值
             */
            value: {
                required: true
            },
            /**
             * 是否可用
             */
            disabled: {
                type: Boolean,
                default: false
            },
            /**
             * 是否显示全部
             */
            all: {
                type: Boolean,
                default: false
            },
            /**
             * 是否允许清除
             */
            clearable: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            value: function (newVal) {
                if (newVal != null && newVal !== '') {
                    this.selectValue = newVal + ""
                } else {
                    this.selectValue = ''
                }
            },
            parent: function (newVal) {
              if (newVal != null && newVal !== '') {
                this.initData()
                this.selectValue = ''
              }
            },
            area: function (newVal) {
              if (newVal != null && newVal !== '') {
                this.initData()
                this.selectValue = ''
              }
            },
        },
        created() {
            this.initData()
        },
        methods: {
            changeOption(item) {
                this.$emit("update:value", item);
            },
            initData() {
                this.selectValue = this.value + ''
                //if (this.bankList === undefined || this.bankList.length === 0) {
                    this.$http({
                        url: this.$http.adornUrl('/sys/bank/getBanksByTypeAndLevel'),
                        method: 'get',
                        params: this.$http.adornParams({"type": this.type,"level":this.level,"parent":this.parent,"area":this.area})
                    }).then(({data}) => {
                        if (data && data.code === 0) {
                            this.bankList = []
                            data.data.forEach(item => {
                                this.bankList.push({bankName: item.bankName, id: item.id.toString()})
                            });
                            if (this.all) {
                                this.bankList.unshift({bankName: "全部", id: ""})
                            }
                        }
                    })
                //}
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/bank/bank-type-level-select.vue